import { useContext, useEffect, useRef, useState } from 'react'
import Banner from '../component/Banner'
import { gsap } from 'gsap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import Card from '../component/card';
import Loader from '../component/Loader';
import axios from 'axios';
import { ProductContext } from '../context/productContext';
import { useSettings } from '../context/settingContext';

function Shop() {

  const { featuredProducts, products } = useContext(ProductContext)
  const slidesRef = useRef([]);

  useEffect(() => {
    slidesRef.current.forEach((slide, i) => {
      gsap.fromTo(
        slide,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          delay: i * 0.2,
          scrollTrigger: {
            trigger: slide,
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
        }
      );
    });
  }, []);

  const [banner, setBanner] = useState(null);
  const [pageContent, setPageContent] = useState(null);

  const getBanner = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/get-content/ShopPage`
      );
      setBanner(res.data.data[0]);
    } catch (err) {
      console.log("Fetching Banner Content", err);
    }
  };

  const getPageContent = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/get-content/shopPageContent`
      );
      setPageContent(res.data.data);
    } catch (err) {
      console.log("Fetching Page Content", err);
    }
  };

  const [wishlist, setWishlist] = useState([]);
  const { user } = useSettings();
  const userId = user?.id;

  useEffect(() => {
    const fetchWishlist = async () => {
      if (!userId) return;
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}api/listing-wishlist?user_id=${userId}`);
        setWishlist(res.data.data || []);
      } catch (err) {
        console.log("Error fetching wishlist:", err);
      }
    };
    fetchWishlist();
  }, [userId]);

  useEffect(() => {
    getBanner();
    getPageContent();
  }, []);

  if (banner === null || pageContent === null) {
    return <Loader />
  }

  return (
    <div className='shop_pgg'>
      <Banner
        Title={banner.title}
        secttile={banner.sub_title}
        dec1={banner.short_details}
        dec2={banner.details}
        img={`${process.env.REACT_APP_SITE_IMAGES}${banner.image}`}
      />
      <div className="main-droper bg-black pt-20 pb-20">
        <div className="conatiner mx-auto px-4">
          <div className="banner-text">
            <h1 className='font-syne text-8xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]'>
              {pageContent[0].title}
            </h1>
            <p className='font-outfit text-center text-white pt-[25px] w-[80%] m-auto'>
              {pageContent[0].details}
            </p>
          </div>
          <div className="mt-16 w-full">
            <Swiper
              modules={[Navigation]}
              navigation
              spaceBetween={30}
              slidesPerView={4}
              className="crafted-swiper w-full">
              {products.map((product, index) => (
                <SwiperSlide key={index}>
                  <div ref={(el) => (slidesRef.current[index] = el)}>
                    <Card
                      key={product.id}
                      {...product}
                      isWishlisted={
                        wishlist.some((item) => item.item_id === product.id)
                      }
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      <div className="bg-black pt-20 pb-20">
        <div className="container mx-auto px-4">
          <div className="banner-text">
            <h2 className="font-syne text-8xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]">
              {pageContent[1].title}
            </h2>
            <p className="font-outfit text-center text-white pt-[25px]">
              {pageContent[1].details}
            </p>
          </div>

          <div className="mt-16 w-full">
            <Swiper
              modules={[Navigation]}
              navigation
              spaceBetween={30}
              slidesPerView={4}
              className="crafted-swiper w-full">
              {featuredProducts.map((product, index) => (
                <SwiperSlide key={index}>
                  <div ref={(el) => (slidesRef.current[index] = el)}>
                    <Card
                      key={product.id}
                      {...product}
                      isWishlisted={
                        wishlist.some((item) => item.item_id === product.id)
                      }
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      {/* <div className="main-droper bg-black pt-20 pb-20">
        <div className="conatiner mx-auto px-4">
          <Row gutter={20} className="crafted-row motion-flex  align-items-center">
            <Col span={8}>
              <div className="text-1">
                <h1 className='font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent'>
                  {pageContent[2].title}
                </h1>
                <p className='text-[15px] font-outfit  text-white pt-[25px] pt-5 pb-5 text-white w-[480px]'>
                  {pageContent[2].details}
                </p>
              </div>
            </Col>

            <Col span={16} className=''>
              <Swiper
                modules={[Navigation]}
                navigation
                margin={20}
                width={1000}
                slidesPerView={3}
                className="crafted-swiper"
              >
                {cardData.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div ref={(el) => (slidesRef.current[index] = el)}>
                      <Card
                        img={img}
                        title={item.title}
                        oldPrice={item.oldPrice}
                        newPrice={item.newPrice}
                        image={item.image}
                        volumes={item.volumes}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </div>
      </div>
      <div className="bg-black pt-20 pb-20">
        <div className="container mx-auto px-4">
          <div className="banner-text">
            <h2 className="font-syne text-8xl text-center font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent m-auto w-full max-w-[900px]">
              {pageContent[3].title}
            </h2>
            <p className="font-outfit text-center text-white pt-[25px]">
              {pageContent[3].details}
            </p>
          </div>

          <div className="mt-16 w-full">
            <Swiper
              modules={[Navigation]}
              navigation
              spaceBetween={30}
              slidesPerView={4}
              className="crafted-swiper w-full"
            >
              {cardData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div ref={(el) => (slidesRef.current[index] = el)}>
                    <Card img={img1}
                      title={item.title}
                      oldPrice={item.oldPrice}
                      newPrice={item.newPrice}
                      image={item.image}
                      volumes={item.volumes}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default Shop
